"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    attrs: {
      id: "app"
    }
  }, [_c("router-view"), _c("service-worker-update-popup"), _c("el-dialog", {
    attrs: {
      visible: _vm.isCountingDown,
      width: "400px",
      center: "",
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function ($event) {
        _vm.isCountingDown = $event;
      }
    }
  }, [_c("div", {
    staticStyle: {
      "text-align": "center",
      padding: "20px"
    }
  }, [_c("h2", {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v(" ⚠ Session Expiring ")]), _c("div", {
    staticStyle: {
      "font-size": "40px",
      "font-weight": "bold",
      color: "#f56c6c",
      margin: "20px 0"
    }
  }, [_vm._v(" " + _vm._s(_vm.countdownSeconds) + "s ")]), _c("p", [_vm._v("Your session will expire due to inactivity.")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.stayLoggedIn
    }
  }, [_vm._v(" Stay Logged In ")])], 1)])], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;